<template>
  <!-- Connect with people -->
  <section class="connect-people has-text-centered">
    <h2 class="connect-people-title h1">
      {{ $t('page.whatIsLiffery.people.title') }}
    </h2>
    <p class="connect-people-text">
      {{ $t('page.whatIsLiffery.people.text') }}
    </p>
    <img
         src="@/assets/landing-pages/new/connect-with-people-min.png"
         srcset="@/assets/landing-pages/new/connect-with-people-min.png 1x, @/assets/landing-pages/new/connect-with-people.png 2x"
         alt="Connect with people"
         class="connect-people-image"/>
    <div class="connect-people-ellipse-left"></div>
    <div class="connect-people-ellipse-right"></div>
  </section>
</template>


<style scoped lang="scss">
.connect-people {
  position: relative;
  padding-top: 7.5rem;
  padding-bottom: 1rem;
  color: $black;

  &::after {
    content: "";
    position: absolute;
    top: -3px;
    right: 0;
    left: 0;
    height: 13.7rem;
    background: linear-gradient(180deg, rgba(81, 156, 123, 0.1) 0%, rgba(196, 196, 196, 0) 100%, rgba(255, 255, 255, 0) 100%);
  }

  &-text {
    max-width: 52.95rem;
    margin: 2rem auto -2rem;
    line-height: 1.412rem;
  }

  &-image {
    position: relative;
    z-index: 1;
  }

  &-ellipse-left,
  &-ellipse-right {
    position: absolute;
    top: 60%;
    z-index: 0;
    width: 11rem;
    height: 11rem;
    background: rgba($primary, .7);
    transform: translateY(-50%);
    @include filterBlur(70px);
  }

  &-ellipse-left {
    left: -7.412rem;
  }

  &-ellipse-right {
    right: -7.412rem;
  }

  @media screen and (max-width: $tablet) {
    padding-top: 4rem;

    &-title,
    &-text {
      padding-right: 2rem;
      padding-left: 2rem;
    }

    &-text {
      margin-top: 1rem;
      margin-bottom: 2rem;
    }

    &-image {
      transform: scale(1.4);
    }
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OConnectPeople extends Vue {
}
</script>
